import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home.component';
import { canActivateGuard } from 'src/app/guards/auth.guard';
import { SitesComponent } from 'src/app/modules/sites/components/sites/sites.component';
import { ProfileComponent } from 'src/app/modules/shared/components/profile/profile.component';
import { ClouseAccountComponent } from 'src/app/modules/shared/components/close-account/close-account.component';
import { SupportComponent } from 'src/app/modules/support/component/support-user/support-user.component';
import { ScenariosComponent } from 'src/app/modules/scenarios/components/scenarios/scenarios.component';
import { HelperComponent } from 'src/app/modules/help/components/helper/helper.component';
import { DevicesListComponent } from 'src/app/modules/sites/components/devices-list/devices-list.component';
import { DeviceComponent } from 'src/app/modules/device/components/device/device.component';
import { PermissionsComponent } from 'src/app/modules/permissions/components/permissions/permissions.component';
import { EventsComponent } from 'src/app/modules/events/components/events/events.component';
import { ListDeviceSupportComponent } from 'src/app/modules/list-device-support/list-device-support/list-device-support.component';


const routes: Routes = [
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [canActivateGuard],
        children: [
            { path: 'sites', component: SitesComponent },
            { path: 'devices', component: DevicesListComponent },
            { path: 'devices/:deviceId', component: DeviceComponent },
            { path: 'support', component: SupportComponent },
            { path: 'scenarios', component: ScenariosComponent },
            { path: 'permissions', component: PermissionsComponent },
            { path: 'events', component: EventsComponent },
            { path: 'helper', component: HelperComponent },
            { path: 'profile', component: ProfileComponent },
            { path: 'close-account', component: ClouseAccountComponent },
            { path: 'supportDevice', component: ListDeviceSupportComponent },

        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HomeRoutingModule { }
